module.exports = __webpack_public_path__ + "media/images/web/home/index/customizable-dc6e38bf6908ba48b664b5eb5a10c401.jpg";